import React from 'react';
import Button from 'react-bootstrap/Button';
import i18n from 'i18n';
import clsx from 'clsx';

interface RefreshDataBtnProps {
  isExportInProgress: boolean;
  onClick: () => void;
}

const RefreshBtn = (props: RefreshDataBtnProps) => {
  const { isExportInProgress, onClick } = props;

  return (
    <Button
      title={isExportInProgress ? 'Export job is in progress...' : i18n.t('analytics:inspection.header.refreshRequest')}
      className={'btn title-enabled btn-primary btn-sm float-right mr-2 position-relative'}
      disabled={isExportInProgress}
      onClick={() => onClick()}
      style={{ bottom: '6px' }}
    >
      <div className={clsx(isExportInProgress ? 'spinning-animation' : undefined, 'd-inline-block')}>
        <i className="icon-bzm-sync icon-xs" />
      </div>
      <span className={'position-relative ml-2'} style={{ bottom: '2px' }}>
        {i18n.t('analytics:inspection.header.refresh')}
      </span>
    </Button>
  );
};

export default RefreshBtn;
